import { render, staticRenderFns } from "./ValuationTab.vue?vue&type=template&id=4f9728f2&scoped=true"
import script from "./ValuationTab.vue?vue&type=script&lang=js"
export * from "./ValuationTab.vue?vue&type=script&lang=js"
import style0 from "./ValuationTab.vue?vue&type=style&index=0&id=4f9728f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9728f2",
  null
  
)

export default component.exports